<template>
  <div class="cart-payment">
    <div v-if="type == 'subscription'">
      <div class="row">
        <div class="col">
          <img
            :src="new_subscription.product.url_image"
            :alt="new_subscription.product.name"
            class="img-cart-subscription"
          />
        </div>
        <div class="col d-flex align-items-center justify-content-center">
          <p class="color-white h3 font-general-r">{{ new_subscription.product.name }}</p>
        </div>
        <div class="col d-flex align-items-center justify-content-center">
          <p class="color-white h3 font-general-r">{{ currencyFormat(new_subscription.price) }}</p>
        </div>
      </div>
      <div class="border-white mt-10"></div>
      <div class="row">
        <div class="col d-flex align-items-center justify-space-between">
          <p class="color-white font-general-r">SUBTOTAL</p>
          <p class="color-white font-general-r">{{ currencyFormat(new_subscription.price) }}</p>
        </div>
      </div>
      <div class="border-white"></div>
      <div class="row">
        <div class="col d-flex align-items-center justify-space-between">
          <p class="color-white font-general-r">TOTAL</p>
          <p class="color-white h4 font-general-r">{{ currencyFormat(new_subscription.price) }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p class="color-white h5 font-general-r">
            {{ new_subscription.subscription_type.name }}
          </p>
          <p class="color-white h5 font-general-r">
            Has indicado que no te gusta o eres alérgico a: {{ new_subscription.comments }}
          </p>
        </div>
      </div>
    </div>

    <div v-if="type == 'cart'" class="pt-2">

      <!--este div es para la campaña dilo con nieve-->
      <div v-if="campaign_order && campaign_order.date == now" class="row py-2 mb-2">
        <div class="col text-center">
          <img class="frascos_campania" src="@/assets/store/diloconnieve/frascos.svg" alt="">
        </div>
      </div>
      <!--fin del div-->

      <simplebar style="max-height: 420px;">
        <div class="row pb-5" v-for="(item, index) of cart.cart_products" :key="index">
          <div class="col text-center mt-3">
            <v-badge
              right
              :content="`${item.quantity}`"
              color="blank"
              offset-x="15"
              offset-y="10"
            >
              <img
                :src="item.product.url_image_flask"
                :alt="item.product.name"
                class="img-product-cart-payment"
              />
            </v-badge>
          </div>
          <div class="col d-flex align-items-center justify-content-start">
            <span class="color-white font-general-r">
              <p class="h4">{{ item.product.name.toUpperCase() }}</p>
              <p v-if="item.option_size" class="h6">{{ item.option_size.toUpperCase() }}</p>
            </span>
          </div>
          <div class="col d-flex align-items-center justify-content-center">
            <p :class="`h3 font-general-r ${item.discount ? 'price-discount text-danger' : 'color-white' }`">{{ currencyFormat(item.subtotal) }}</p>
          </div>
        </div>
      </simplebar>
      <div class="border-white"></div>

      <DiscountCode
        v-show="step_payment_order == 'shipping_data'"
        @appliedDiscount="appliedDiscount"
      />

      <div class="border-white"></div>
      <div class="row pt-5">
        <div class="col d-flex align-items-center justify-content-between">
          <p class="color-white font-general-r">SUBTOTAL</p>
          <p class="color-white font-general-r">{{ currencyFormat(cart_total) }}</p>
        </div>
      </div>

      <div class="row" v-if="select_discount">
        <div class="col d-flex align-items-center justify-content-between">
          <p class="color-white font-general-r">DESCUENTO APLICADO: {{ select_discount.code }}</p>
          <p class="color-white font-general-r">
            {{ select_discount && select_discount.type != 'shipping_free' ? currencyFormat(amount_discount) : 'ENVÍO GRATIS' }}
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col d-flex justify-content-between flex-wrap">
          <p class="color-white font-general-r">ENVÍOS</p>
          <p v-if="step_payment != ''" class="color-white font-general-r">
            {{ currencyFormat(shipping_price) }}
          </p>
          <p v-else class="color-white font-general-r">
            CALCULADO EN EL SIGUIENTE PASO
          </p>
        </div>
      </div>
      <div class="border-white"></div>
      <div class="row pt-5 pb-5">
        <div class="col d-flex align-items-center justify-content-between">
          <p class="color-white font-general-r">TOTAL</p>
          <p class="color-white h4 font-general-r">
            {{ shipping_price != '' ? currencyFormat(total_cart + shipping_price) : currencyFormat(total_cart) }}
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { currencyFormat } from '@/helpers'
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';
import DiscountCode from '@/components/store/DiscountCode'
import moment from 'moment'

export default {
  components: { simplebar, DiscountCode },
  props: ['shipping_price', 'step_payment'],
  data() {
    return {
      now: moment().format('YYYY-MM-DD'),
      type: '',
      discount_code: '',
      loading_btn_discount: false,
      data_discount: null,
      amount_discount: 0
    }
  },
  computed: {
    ...mapState(['select_discount', 'campaign_order', 'cart_total', 'step_payment_order', 'cart', 'is_auth', 'user', 'new_subscription', 'number_day']),
    ...mapGetters(['total_cart'])
  },
  methods: {
    currencyFormat(price) {
			return currencyFormat(price)
    },
    appliedDiscount(data) {
      if (data.applied) {
        this.data_discount = data.discount
        this.amount_discount = data.total_discount

        this.$emit('appliedDiscount', { dis: data.discount, applied: data.applied })
      } else {
        this.$swal('No cumples las condiciones para aplicar este descuento', '', 'warning')
      }
    }
  },
  watch: {
    step_payment(newval) {
      if (newval != 'payment_data') {
        this.data_discount = null
        this.amount_discount = 0
      }
    }
  },
  mounted() {
    if (this.$route.name == 'SubscriptionPayment') {
      this.type = 'subscription'
    } else {
      this.type = 'cart'
    }
  }
}
</script>

<style scoped>
  >>>.v-badge__badge {
    color: var(--color-tertiary) !important;
    font-family: var(--font-baloo-regular) !important;
  }
  .cart-payment {
    height: 100%;
    background-color: var(--color-tertiary);
    padding: 2em;
    width: 100%;
  }
  >>>.simplebar-scrollbar::before {
    background-color : var(--color-secondary);
  }
</style>
